// @flow
import * as React from 'react';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { FormattedMessage, IntlShape, injectIntl } from 'react-intl';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';
import point11Messages from 'esm-web-pro/messages/points11Messages';
import { point12Messages } from 'esm-web-pro/messages/points12Messages';
import StyledFormCheckmark from 'esm-web-pro/components/layout/sidePanel/icons/StyledFormCheckmark';
import { FormClose } from 'grommet-icons';

type Props = {
    cable: Object,
    url: string,
    intl: IntlShape,
    onView: Function,
}

const CableAttributes = (props: Props) => {
    const {
        cable, url, intl: { formatMessage }, onView,
    } = props;

    const {
        tube_count: tubeCount, fiber_count: fiberCount, ref,
        start_container_point: startContainerPoint, end_container_point: endContainerPoint,
        start_termination_point: startTerminationPoint, end_termination_point: endTerminationPoint,
        length, model, export: eitExport, brand, infrastructure_provider_entity_name: infrastructureProviderEntityName,
    } = cable;

    const getPointAttributes = (containerPoint, terminationPoint) => {
        const pointValues = [{
            value: `${formatMessage(point11Messages[containerPoint.type])} ${
                containerPoint.type === 'pop' && containerPoint.alias
                    ? containerPoint.alias
                    : containerPoint.sequence
            }`,
            link: `${url.split('/layer')[0]}/layer/${containerPoint.type}/${containerPoint.identity}`,
        }];
        if (terminationPoint) {
            pointValues.push({
                value: `${formatMessage(point12Messages[terminationPoint.type])} ${terminationPoint.sequence}`,
                link: `${url.split('/layer')[0]}/layer/${
                    terminationPoint.type}/${terminationPoint.identity}`,
            });
        }
        return pointValues;
    };

    const attributes = [
        {
            label: formatMessage(attributeMessages.provider),
            value: infrastructureProviderEntityName,
        },
        {
            label: formatMessage(attributeMessages.ref),
            value: ref,
            onClick: onView,
        },
        {
            label: formatMessage(attributeMessages.model),
            value: model,
            link: model ? `${url}/model/${model.code}`.replace('//', '/') : '',
        },
        {
            label: <FormattedMessage id="cable-attributes-length" defaultMessage="Length" />,
            value: <FormattedMessage
                id="cable-attributes-length-value"
                defaultMessage="{value} m."
                values={{ value: length }}
            />,
        },
        {
            label: <FormattedMessage id="cable-attributes-tube-count" defaultMessage="Tube Count" />,
            value: tubeCount,
        },
        {
            label: <FormattedMessage id="cable-attributes-fiber-count" defaultMessage="Fiber Count" />,
            value: fiberCount,
        },
        {
            label: formatMessage(attributeMessages.export),
            value: eitExport ? <StyledFormCheckmark /> : <FormClose />,
        },
    ];

    if (brand) {
        attributes.push(
            {
                label: <FormattedMessage id="cable-attributes-brand" defaultMessage="Brand" />,
                value: brand,
            },
        );
    }

    attributes.splice(3, 0, {
        label: formatMessage(attributeMessages.start),
        multiValue: getPointAttributes(startContainerPoint, startTerminationPoint),
        separator: ', ',
    });

    attributes.splice(4, 0, {
        label: formatMessage(attributeMessages.end),
        multiValue: getPointAttributes(endContainerPoint, endTerminationPoint),
        separator: ', ',
    });

    return <Attributes attributes={attributes} />;
};

export default injectIntl(CableAttributes);
